import Concurrency from './Concurrency';
import resolveConcurrencyActions from './resolveConcurrencyActions';
import StoreName from '../Shared/Constants/StoreName';

const createConcurrencyStore = state =>
    state.createStore({
        name: StoreName.CONCURRENCY,
        model: Concurrency,
        actions: resolveConcurrencyActions,
    });

export default createConcurrencyStore;
